import React from 'react';
import styled from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';
import Container from '../components/Container/Container';
import { Wrapper } from '../components/Container/Wrapper';
import Title from '../components/Template/Title';
import Project from '../components/Project/Project';
import Grid from '../styles/grid';

import PageTransition from '../components/pageTransition'

const StyledProjects = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const StyledRow = styled.div`
  position: relative;
  width: 100%;
`;

const StyledGrid = styled(Grid)`
  margin-right: ${props => props.alignRight && 'auto'};
`;

const getGrid = i => {
  if (i % 2 === 0) {
    return 7;
  }
  return 5;
};

const getProject = (project, i) => {
  if (project.featured) {
    return (
      <StyledRow key={i}>
        <StyledGrid alignRight md={9}>
          <Project special src={project.image} project={project} />
        </StyledGrid>
      </StyledRow>
    );
  }
  return (
    <StyledGrid key={i} alignRight md={getGrid(i)}>
      <Project src={project.image} project={project} />
    </StyledGrid>
  );
};

const ProjectsPage = () => (
  <StaticQuery
    query={graphql`
      query Projectpage {
        site {
          siteMetadata {
            projects {
              name
              channel
              producer
              location
              summary
              year
              featured
              image
            }
            testimonials {
              content
              author
            }
          }
        }
      }
    `}
    render={data => {
      const { projects } = data.site.siteMetadata;

      return (
        <Layout>
          <SEO title="Our Services" />
          <PageTransition>
            <Wrapper>
              <Title>Projects</Title>
              <Container>
                <StyledProjects>
                  {projects.map((project, i) => {
                    return getProject(project, i);
                  })}
                </StyledProjects>
              </Container>
            </Wrapper>
          </PageTransition>
        </Layout>
      );
    }}
  />
);

export default ProjectsPage;
